import React from "react";
import personaje from "../assets/personaje.png";
import figAzul from "../assets/figuras/fig-azul.png";
import figRojo from "../assets/figuras/fig-rojo.png";
import figNaranja from "../assets/figuras/fig-naranja.png";
import figAmarillo from "../assets/figuras/fig-amarillo.png";
import figTeal from "../assets/figuras/fig-teal.png";
import figCrema from "../assets/figuras/fig-crema.png";

const Hero = () => {
	return (
		<section className="hero" id="inicio">
			<div className="hero__container">
				<div className="hero__content">
					<span className="hero__tag">
						unapologetically caffeinated
					</span>
					<h1 className="hero__title">
						the only daily
						<br />
						<span className="hero__title--accent">dossis</span>
						<br />
						you actually need.
					</h1>
					<p className="hero__subtitle">
						café de especialidad, lattes con cold foam y bebidas que
						no juegan con las reglas
					</p>
					<div className="hero__actions">
						<a href="#menu" className="btn btn--teal">
							see the menu
						</a>
						<a href="#nosotros" className="btn btn--outline">
							our story
						</a>
					</div>
				</div>

				<div className="hero__visual">
					<img
						src={figAzul}
						alt=""
						className="hero__blob hero__blob--azul"
						aria-hidden="true"
					/>
					<img
						src={figCrema}
						alt=""
						className="hero__blob hero__blob--crema"
						aria-hidden="true"
					/>
					<img
						src={figTeal}
						alt=""
						className="hero__blob hero__blob--teal"
						aria-hidden="true"
					/>
					<img
						src={figNaranja}
						alt=""
						className="hero__blob hero__blob--naranja"
						aria-hidden="true"
					/>
					<img
						src={personaje}
						alt="Personaje Dossis"
						className="hero__personaje"
					/>
					<img
						src={figAmarillo}
						alt=""
						className="hero__blob hero__blob--amarillo"
						aria-hidden="true"
					/>
					<img
						src={figRojo}
						alt=""
						className="hero__blob hero__blob--rojo"
						aria-hidden="true"
					/>
				</div>
			</div>

			<div className="hero__scroll-hint">
				<span>scroll for more</span>
				<div className="hero__scroll-line" />
			</div>
		</section>
	);
};

export default Hero;
